export default "__VITE_ASSET__LyS58_AC__"